/** E.164-style: +, 1–3 digit country code, 6–14 national digits (no spaces). */
export const INTERNATIONAL_PHONE_REGEX = /^\+\d{1,3}\d{6,14}$/;

const MAX_INTERNATIONAL_PHONE_DIGITS = 15;

export function normalizeInternationalPhoneInput(value: string): string {
  if (!value) {
    return "";
  }
  const digitsOnly = value.replace(/\D/g, "");
  if (!digitsOnly) {
    return "";
  }
  const limited = digitsOnly.slice(0, MAX_INTERNATIONAL_PHONE_DIGITS);
  return `+${limited}`;
}

export function isValidInternationalPhone(
  value: string | null | undefined,
): boolean {
  if (!value?.trim()) {
    return true;
  }
  return INTERNATIONAL_PHONE_REGEX.test(
    value.trim().replace(/\s/g, ""),
  );
}

export function getInternationalPhoneFormRules(
  translate: (key: string, defaultValue?: string) => string,
): { validator: (_: unknown, value: string) => Promise<void> }[] {
  return [
    {
      validator: (_: unknown, value: string) => {
        if (!value?.trim()) {
          return Promise.resolve();
        }
        if (isValidInternationalPhone(value)) {
          return Promise.resolve();
        }
        return Promise.reject(
          new Error(
            translate(
              "accounts.validation.internationalPhoneInvalid",
              "Format international requis (ex. +33612345678)",
            ),
          ),
        );
      },
    },
  ];
}
